<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="page--login d-flex justify-center align-center">
          <div class="form-container">
            <v-card class="pa-10">
              <v-form ref="form">
                <v-row>
                  <v-col class="text-center">
                    <img
                      class="app-icon"
                      src="https://cdn.educacao.pe.gov.br/storage/assets/logo_see_eleitoral_branco_c2003fd940.png"
                      alt="Brasão do state de Pernambuco"
                    />
                    <br />
                    <h1
                      class="subtitle-1 blue--text text--darken-4"
                      color="primary"
                      v-text="$appName || 'Acessar o Sistema'"
                    ></h1>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div class="text-center">
                      <h4
                        class="subtitle-2 blue--text"
                        color="primary"
                        v-text="'Recuperação de Senha'"
                      ></h4>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="user.username"
                      solo
                      label="CPF"
                      placeholder="Por favor, informe o CPF cadastrado"
                      v-mask="'###.###.###-##'"
                      @keyup.enter="enter"
                      :rules="[
                        (v) => $required(v, 'CPF é obrigatório'),
                        (v) => $min($unMask(v), 11),
                        (v) => $max($unMask(v), 11),
                      ]"
                      ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="text-center">
                  <v-col cols="12">
                    <v-btn
                      block
                      color="success"
                      :loading="loading"
                      @click.prevent="enviar"
                    >
                      Enviar
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn color="info" small rounded outlined @click.prevent="voltar">Voltar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { CLEAR } from "store";

export default {
  data: () => ({
    loading: false,
    user: {
      username: undefined,
    },
  }),
  beforeMount() {
    this.hidePageLoading();
    this.$store.dispatch(CLEAR);
  },
  methods: {
    enviar() {
      if (this.$validarFormulario()) {
        const cpf = this.user.username.replace(/\D/g, '');
        this.loading = true;
        this.$esqueciSenha({ cpf })
          .then(({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.voltar();
          })
          .catch(({ data }) => {
            this.$notifyError(data.mensagem);
            this.$store.dispatch(CLEAR);
          })
          .finally(() => this.loading = false);
      } else {
        this.$notifyError("Por favor, informe o CPF cadastrado");
      }
    },
    voltar() {
      this.$router.push({ path: '/login' })
    },
  }
};
</script>

<style lang="scss" scoped>
.page--login {
  min-height: calc(100vh - 24px) !important;
  .form-container {
    form {
      min-width: 250px;
      a {
        text-decoration: none;
      }
    }
  }

  .app-icon {
    max-height: 3em;
  }
}
</style>
